import { render, staticRenderFns } from "./customDashboardConfig.vue?vue&type=template&id=2479d25c&scoped=true"
import script from "./customDashboardConfig.vue?vue&type=script&lang=js"
export * from "./customDashboardConfig.vue?vue&type=script&lang=js"
import style0 from "./customDashboardConfig.vue?vue&type=style&index=0&id=2479d25c&prod&lang=scss"
import style1 from "./customDashboardConfig.vue?vue&type=style&index=1&id=2479d25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2479d25c",
  null
  
)

export default component.exports